<template>
<section class="sc-o27kl3-0 gsZmuC product-slider-section mt-5 mb-4 mx-3 rounded px-3" style="background: red;" v-if="props.damping.length > 0">
  <div class="py-3">
    <h3 class="text-light" style="font-size:1.2em;font-weight:600">تخفیف های ویژه</h3>
    <small class="text-light">تخفیف های امروز در فروشگاه {{ props.damping[0].store_place  }}</small>
  </div>
    <div>
      <div class="sc-d8w7bo-1 jpdybm">
        <div direction="row" class="sc-1r3hge1-0 heMFVq scroll-example">
          <product-template :list="props.damping" /> 
        </div>
        <button class="btn w-100" style="background-color: #eef1f9;" @click="goWoleDamp">مشاهده همه</button>
      </div>
    </div>
</section>
</template>
<script setup>
import { defineProps } from 'vue';
import { useRoute,useRouter } from 'vue-router';
import ButtonTemplate from '../../item/button.vue';
import ProductTemplate from '../../item/product.vue';
let route = useRoute()
let router = useRouter()
let props = defineProps(['damping']);
function goWoleDamp(){
  router.push({name:'DampBtn',params:{whole:'damp',storeId:route.params.id}})
}
function addCommas(x) { return PersianNumber(x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));}
function PersianNumber(t){for(t=t.toString();t.search("0")>-1;)t=t.replace("0","۰");for(;t.search("1")>-1;)t=t.replace("1","۱");for(;t.search("2")>-1;)t=t.replace("2","۲");for(;t.search("3")>-1;)t=t.replace("3","۳");for(;t.search("4")>-1;)t=t.replace("4","۴");for(;t.search("5")>-1;)t=t.replace("5","۵");for(;t.search("6")>-1;)t=t.replace("6","۶");for(;t.search("7")>-1;)t=t.replace("7","۷");for(;t.search("8")>-1;)t=t.replace("8","۸");for(;t.search("9")>-1;)t=t.replace("9","۹");return t}
</script>

<style scoped>
@import '../../../../assets/css/product.css';
</style>